import { render, staticRenderFns } from "./UserForm.vue.js?vue&type=template&id=1fb52e4c!=!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@3.6.0_webpack@5.112.0__handlebars@4.7.10_lodash@4.18.1_vu_6aaa316a0b49f59667a617df5dc64b72/node_modules/vue-loader/lib/index.js??vue-loader-options!./UserForm.vue?vue&type=template&id=1fb52e4c"
import script from "./UserForm.vue.js?vue&type=script&lang=js!=!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@3.6.0_webpack@5.112.0__handlebars@4.7.10_lodash@4.18.1_vu_6aaa316a0b49f59667a617df5dc64b72/node_modules/vue-loader/lib/index.js??vue-loader-options!./UserForm.vue?vue&type=script&lang=js"
export * from "./UserForm.vue.js?vue&type=script&lang=js!=!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@3.6.0_webpack@5.112.0__handlebars@4.7.10_lodash@4.18.1_vu_6aaa316a0b49f59667a617df5dc64b72/node_modules/vue-loader/lib/index.js??vue-loader-options!./UserForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@3.6.0_webpack@5.112.0__handlebars@4.7.10_lodash@4.18.1_vu_6aaa316a0b49f59667a617df5dc64b72/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fb52e4c')) {
      api.createRecord('1fb52e4c', component.options)
    } else {
      api.reload('1fb52e4c', component.options)
    }
    module.hot.accept("./UserForm.vue.js?vue&type=template&id=1fb52e4c!=!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@3.6.0_webpack@5.112.0__handlebars@4.7.10_lodash@4.18.1_vu_6aaa316a0b49f59667a617df5dc64b72/node_modules/vue-loader/lib/index.js??vue-loader-options!./UserForm.vue?vue&type=template&id=1fb52e4c", function () {
      api.rerender('1fb52e4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/app/components/routes/user/UserForm.vue"
export default component.exports